import {
  IObjektVy,
  IBusinessCollectionProps,
} from '../../../../../Types/ObjektVy';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { IColumnDef } from '../../../../../Types/ColumnDefType';
import Attribut from './Attribut/Attribut';

// vy som använder visar ett attribut i ett formulär
const attributVy = (columndef: IColumnDef, id?: string): IObjektVy => ({
  type: 'ObjektVy',
  id: columndef.attributeDef,
  info: { komponentMedRubrik: true },
  def: (_: IClientBusinessModel) => {
    const comp = (_: IBusinessCollectionProps) => {
      return <Attribut<{ [key: string]: any }> name={columndef.attributeDef} />;
    };
    return {
      caption: columndef.caption || 'Caption saknas',
      comp: comp,
      dataDependencies: [columndef.attributeDef],
    };
  },
});

export default attributVy;
